<template>
  <div class="downloadClass">
    <img src="homePageIcon.png" />
    <div class="downloadRight">
      <div class="downloadRightTitle">下载竞小侠助手</div>
      <div class="downloadRightSubTitle">Download jingxiaoxia</div>
      <div class="downloadRightInfoText">
        竞小侠助手是一款便捷办公软件，它能实时智能的为员工推送服务信息，方便员工提高工作效率，从而获得更好的工作体验
      </div>
      <div class="downloadTypeClass">
        <PhoneTypeBtn
          @click="androidClick"
          class="btnClass"
          style="margin-right: 40px"
          nomalTextColor="#333333"
          nomalBorderColor="#333333"
          nomalIcon="AndroidIconBlack.png"
          selectIconText="AndroidIcon.png"
          titleText="Android版下载"
          :textFontSize="16"
          :textPadding="16"
          :isSelect="codeType == 0"
        />

        <PhoneTypeBtn
          @click="iphoneClick"
          class="btnClass"
          nomalIcon="iPhoneIconBlack.png"
          selectIconText="iPhoneIcon.png"
          nomalTextColor="#333333"
          nomalBorderColor="#333333"
          titleText="iPhone版下载"
          :textFontSize="16"
          :textPadding="16"
          :isSelect="codeType == 1"
        />
      </div>
      <div class="downloadCodeClass">
        <img style="width: 140px; height: 140px;" src="https://img0.baidu.com/it/u=3584759695,3470619884&fm=253&fmt=auto&app=138&f=GIF?w=198&h=198" />
        <div class="downloadCodeClassText">扫一扫，立即下载</div>
      </div>
    </div>
  </div>
</template>

<script>
import PhoneTypeBtn from "./publicComm/phoneTypeBtn.vue";
export default {
  name: "download",
  components: {
    PhoneTypeBtn,
  },
  data() {
    return {
      // 0安卓 1苹果
      codeType: 0,
    };
  },
  methods: {
    androidClick() {
      this.codeType = 0;
    },
    iphoneClick() {
      this.codeType = 1;
    },
  },
};
</script>

<style scoped>
.downloadClass {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  column-gap: 255px;
  overflow: hidden;
}

.downloadRight {
  width: 504px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.downloadRightTitle {
  font-size: 72px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 72px;
  color: rgba(51, 51, 51, 1);
  text-align: left;
  vertical-align: top;
}

.downloadRightSubTitle {
  margin-top: 16px;
  font-size: 24px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: rgba(102, 102, 102, 1);
  text-align: left;
  vertical-align: top;
  align-self: flex-end;
}

.downloadRightInfoText {
  margin-top: 80px;
  font-size: 30px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 48px;
  color: rgba(102, 102, 102, 1);
  text-align: left;
  vertical-align: top;
  margin-left: 25px;
  margin-right: 25px;
}

.downloadTypeClass {
  margin-top: 80px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.btnClass {
  width: 200px;
  height: 62px;
}

.downloadCodeClass {
  margin-top: 60px;
  height: 140px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.downloadCodeClassText {
  margin-left: 36px;
  font-size: 30px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 30px;
  color: rgba(51, 51, 51, 1);
  text-align: left;
  vertical-align: top;
}
</style>